import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";

export const AddChat = createAsyncThunk(
  "AddChat",
  async ({ values }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('multipart/form-data', dispatch).post('chat', values);
      successMessage(response.data.message.details);
      dispatch(GetChatsList({ page: 1, usersPerPage: 10, query: "" }))
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const AddMessage = createAsyncThunk(
  "AddMessage",
  async ({ values }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('multipart/form-data', dispatch).post('chat', values);
      successMessage(response.data.message.details);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetChatsList = createAsyncThunk(
  "GetChatsList",
  async ({ page, chatsPerPage, query = "" }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`chat?page=${page}&limit=${chatsPerPage}&search=${query}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetMessagesList = createAsyncThunk(
  "GetMessagesList",
  async ({ receiver,sender, query = "" }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`chat/messages?search=${query}&sender=${sender}&receiver=${receiver}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);


export const UpdateChat = createAsyncThunk(
  "UpdateChat",
  async ({ id, values }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('multipart/form-data', dispatch).put(`chat/${id}`, values);
      successMessage(response.data.message.details);
      dispatch(GetChatsList({ page: 1, usersPerPage: 10, query: "" }))
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

